import React from "react";
import "./About.css";
import Footer from "../components/Footer";

function About() {
  return (
    <>
      <section id="aboutCompanyWrapper">
        <section id="aboutCompany">
          <h1>About Us</h1>
          <h3>
            Welcome to our company! We are a small but highly dedicated and
            professional team based in the heart of Bosnia and Herzegovina, in
            the beautiful city of Banja Luka. Our team consists of talented
            experts with exceptional skills in precision metal processing and
            operating state-of-the-art CNC machines, including the latest fiber
            laser technology.
          </h3>
          <h3>
            We specialize in the production of high-quality metal business cards
            that combine functionality, aesthetics, and durability. We use only
            premium stainless steel, carefully processed with cutting-edge
            equipment to ensure a superior finish and exceptional quality in
            every product.
          </h3>
          <h1>Our Vision</h1>
          <h3>
            The idea for our product was born out of frustration with the
            abundance of low-quality, paper, and generic business cards that
            often look unattractive, wear out quickly, and end up in the trash.
            We wanted to create something entirely different—business cards that
            people will keep, cards so well-crafted, heavy, and impressive that
            it would feel like a shame to throw them away.
          </h3>
          <h3>
            Our goal was to help our clients truly stand out in a sea of
            sameness. With our metal business cards, every first impression
            becomes unique, and our clients leave a lasting and unforgettable
            message.
          </h3>
          <h1>Our Production Process</h1>
          <h3>
            Our entire production process is carefully designed to meet the
            highest quality standards:
          </h3>
          <ul>
            <li>
              High-quality raw materials – Each card begins with carefully
              selected materials that guarantee durability and aesthetics.
            </li>
            <li>
              Custom designs – Our team develops unique designs in collaboration
              with clients to ensure a personalized product.
            </li>
            <li>
              Advanced software – The designs are transferred to our specialized
              engraving software, preparing them for final processing.
            </li>
            <li>
              Precise laser processing – The materials are then processed using
              state-of-the-art fiber lasers, with each card completed down to
              the finest detail.
            </li>
            <li>
              Quality control – Every card goes through five different stages of
              manual inspection to ensure the perfection of the final product.
            </li>
            <li>
              Secure packaging – Once completed, the cards are carefully packed
              to prevent any damage during transport.
            </li>
          </ul>
          <h1>Production Time</h1>
          <h3>
            Our goal is to deliver a superior product in the shortest possible
            time. The production process takes up to 15 business days from the
            moment the order is placed, as we strive to make each card perfect.
          </h3>
          <h3>
            Thank you for choosing our company! Your trust motivates us to
            pursue perfection every day. We are ready to help you leave a
            remarkable and lasting impression.
          </h3>
        </section>
      </section>
      <Footer />
    </>
  );
}

export default About;
